import React from "react";
import { AuthPaymentContainer } from "../../authenticated-payments/misc/auth-payment-container.component";
import { AuthRestartButton } from "../../authenticated-payments/misc/restart-button.component";

const TravelExemptionDenied = (props) => {
  const title = "Request Denied";
  const subtitle = "Please call us at 888-267-7200 for help with placing a Travel Exemption.";

  return (
    <React.Fragment>
      <AuthPaymentContainer title={title} subtitle={subtitle} hide={true}></AuthPaymentContainer>
      <AuthRestartButton
        backToLoans={props.backToLoans}
        extraStyles={{ maxWidth: "570px", margin: "auto" }}
      />
    </React.Fragment>
  );
};

export default TravelExemptionDenied;



// WEBPACK FOOTER //
// ./src/components/card-controls/misc/travel-exemption-denied.component.js